import React from "react";

export default function EasterFrame6({ frameTextToggle, children }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 2000 2000"
      width="300"
      height="300"
      fill="none"
    >
      <g transform={frameTextToggle}>
        <defs>
          <style>
            {
              ".clse6-1{fill:#1b1b36}.clse6-2{fill:#6588c7}.clse6-3{fill:#fcbe5f}"
            }
          </style>
        </defs>
        <path
          className="clse6-1"
          d="M1668.47 1770.45H369.63a122.34 122.34 0 0 1-122.2-122.2V349.41a122.34 122.34 0 0 1 122.2-122.2h1298.84a122.33 122.33 0 0 1 122.19 122.2v1298.84a122.33 122.33 0 0 1-122.19 122.2ZM369.63 271.21a78.29 78.29 0 0 0-78.2 78.2v1298.84a78.29 78.29 0 0 0 78.2 78.2h1298.84a78.28 78.28 0 0 0 78.19-78.2V349.41a78.28 78.28 0 0 0-78.19-78.2Z"
        />
        <path
          className="clse6-2"
          d="M1862 1414.35c-25 21.45-33.15 48.17-35.92 62a6.38 6.38 0 0 0 6.55 7.61c14.12-.65 41.77-4.75 66.72-26.2s33.15-48.17 35.92-62a6.38 6.38 0 0 0-6.55-7.61c-14.12.65-41.72 4.75-66.72 26.2Z"
        />
        <path
          className="clse6-3"
          d="M1827.4 1408.88c-12.55 30.41-7.79 57.95-4 71.57a6.38 6.38 0 0 0 9.28 3.83c12.3-7 35.1-23.13 47.66-53.54s7.79-58 4-71.57a6.37 6.37 0 0 0-9.28-3.83c-12.3 6.96-35.06 23.13-47.66 53.54Z"
        />
        <path
          className="clse6-3"
          d="M1807.94 1411.89c21.39 25 25.42 52.66 26 66.78a6.38 6.38 0 0 1-7.63 6.53c-13.86-2.8-40.56-11.07-61.95-36.07s-25.42-52.66-26-66.78a6.38 6.38 0 0 1 7.63-6.53c13.86 2.8 40.56 11.07 61.95 36.07Z"
        />
        <path
          className="clse6-2"
          d="M1762.93 1565.79a68.61 68.61 0 0 0 25.55 36.45 4 4 0 0 0 6-1.7 67.52 67.52 0 0 0-22.86-80.88 4 4 0 0 0-6 1.7 68.62 68.62 0 0 0-2.69 44.43Z"
        />
        <path
          className="clse6-2"
          d="M1818.52 1577.8a55.78 55.78 0 0 0-28.87 21.82 3.22 3.22 0 0 0 1.55 4.83 54.93 54.93 0 0 0 65.06-20.94 3.22 3.22 0 0 0-1.55-4.83 55.86 55.86 0 0 0-36.19-.88Z"
        />
        <path
          className="clse6-2"
          d="M1719.09 1753.45a5 5 0 0 1-5-4.7c-1.86-31 3.2-59.45 15-84.56 11.93-25.31 27.33-40 42.22-54.3 14-13.41 27.25-26.08 37.51-47.1 13.05-26.74 16.8-58.89 11.13-95.55a5 5 0 0 1 9.89-1.52c6 38.71 1.93 72.85-12 101.46-11 22.62-25.54 36.5-39.57 49.93-14.89 14.25-29 27.71-40.1 51.35s-15.85 50.38-14.1 79.69a5 5 0 0 1-4.69 5.29Z"
        />
        <path
          className="clse6-1"
          d="M1789.67 1420.55c5.18 32.49 23.62 53.49 34 63.11a6.38 6.38 0 0 0 9.92-1.58c6.85-12.37 17.85-38.06 12.67-70.55s-23.62-53.49-34-63.12a6.39 6.39 0 0 0-9.92 1.58c-6.85 12.37-17.85 38.06-12.67 70.56ZM1549.78 1209.54c34.79 36.29 43.33 78.12 45.49 99.61a9.75 9.75 0 0 1-11.08 10.62c-21.38-3.07-62.81-13.38-97.59-49.67s-43.33-78.12-45.49-99.61a9.75 9.75 0 0 1 11.08-10.62c21.37 3.07 62.81 13.38 97.59 49.67Z"
        />
        <path
          className="clse6-3"
          d="M1603.2 1206.3c14.62 48.1 3.32 89.28-4.47 109.42a9.75 9.75 0 0 1-14.68 4.46c-17.68-12.4-50-40.33-64.59-88.43s-3.32-89.27 4.47-109.41a9.74 9.74 0 0 1 14.68-4.46c17.68 12.4 49.97 40.33 64.59 88.42Z"
        />
        <path
          className="clse6-1"
          d="M1632.35 1213.74c-36.2 34.88-46.4 76.34-49.42 97.72a9.75 9.75 0 0 0 10.65 11c21.48-2.21 63.29-10.86 99.5-45.73s46.4-76.34 49.42-97.72a9.75 9.75 0 0 0-10.65-11c-21.48 2.21-63.3 10.86-99.5 45.73Z"
        />
        <path
          className="clse6-2"
          d="M1658.86 1229.6c-12.65 48.64-43.79 77.86-61 91a9.76 9.76 0 0 1-14.85-3.87c-8.59-19.81-21.55-60.5-8.89-109.14s43.8-77.86 61-91a9.75 9.75 0 0 1 14.85 3.86c8.6 19.81 21.55 60.55 8.89 109.15ZM1678.14 1454.38c-11.34 29.08-32.67 44.84-44.2 51.67a6.06 6.06 0 0 1-8.88-3.46c-3.86-12.84-8.89-38.88 2.45-68s32.67-44.83 44.21-51.67a6 6 0 0 1 8.87 3.47c3.87 12.88 8.9 38.91-2.45 67.99Z"
        />
        <path
          className="clse6-2"
          d="M1591.85 1464.46a85.22 85.22 0 0 1 40.69 37.44 4.92 4.92 0 0 1-3.07 7.11 83.91 83.91 0 0 1-95.85-41.41 4.93 4.93 0 0 1 3.08-7.11 85.22 85.22 0 0 1 55.15 3.97Z"
        />
        <path
          className="clse6-2"
          d="M1717.94 1743.09a4.14 4.14 0 0 1-.7-.06 4.49 4.49 0 0 1-3.75-5.14c7.06-44.84 3.75-86.83-9.86-124.8-13.67-38.13-34.16-61.94-54-85-19.18-22.27-39-45.31-52.27-80.8-16.8-45-17.9-96.82-3.27-154.18a4.5 4.5 0 1 1 8.72 2.22c-14.17 55.55-13.16 105.62 3 148.81 12.69 34 31.14 55.41 50.66 78.08 20.36 23.65 41.41 48.1 55.64 87.8 14.12 39.41 17.58 82.9 10.28 129.24a4.5 4.5 0 0 1-4.45 3.83Z"
        />
        <path
          className="clse6-1"
          d="M1640.3 1555.73c13.33 12.46 17.72 28 19.19 36a3.61 3.61 0 0 1-3.5 4.42 56.28 56.28 0 0 1-35.65-15.23c-13.34-12.46-17.72-28-19.2-36a3.62 3.62 0 0 1 3.5-4.42 56.28 56.28 0 0 1 35.66 15.23Z"
        />
        <path
          className="clse6-2"
          d="M1658.79 1552.55a69.53 69.53 0 0 1 2.13 41.59 3.33 3.33 0 0 1-5 2.22 62.39 62.39 0 0 1-25.47-31.11 69.45 69.45 0 0 1-2.13-41.59 3.34 3.34 0 0 1 5-2.23 62.47 62.47 0 0 1 25.47 31.12Z"
        />
        <path
          className="clse6-3"
          d="M1669.19 1554.3c-11.43 14.53-13.58 30.6-13.91 38.81a3.51 3.51 0 0 0 4.07 3.79 58 58 0 0 0 33.11-21c11.43-14.53 13.59-30.6 13.92-38.81a3.51 3.51 0 0 0-4.08-3.79 58 58 0 0 0-33.11 21Z"
        />
        <path
          className="clse6-2"
          d="M1693.24 1643.73a39.84 39.84 0 0 1-13.65 21.18 2 2 0 0 1-3.21-1 43.19 43.19 0 0 1-1.43-25.82 39.84 39.84 0 0 1 13.65-21.19 2 2 0 0 1 3.21 1 43.1 43.1 0 0 1 1.43 25.83Z"
        />
        <path
          className="clse6-2"
          d="M1663.53 1650.71a30.29 30.29 0 0 1 15.44 12.68 2 2 0 0 1-.83 2.8 27.52 27.52 0 0 1-19.34.52 30.4 30.4 0 0 1-15.43-12.68 1.94 1.94 0 0 1 .83-2.81 27.56 27.56 0 0 1 19.33-.51Z"
        />
        <path
          className="clse6-2"
          d="M1716.66 1753.15h-.17a3 3 0 0 1-2.83-3.16c.94-17.06-1.6-32.66-7.54-46.37s-13.46-21.54-21.41-29.81c-7.5-7.81-15.27-15.89-21.17-29-7.46-16.61-9.62-36.42-6.43-58.9a3 3 0 0 1 6 .85c-3 21.33-1 40 6 55.59 5.48 12.2 12.55 19.56 20 27.34 8 8.29 16.2 16.87 22.58 31.58s9 31.09 8 49.09a3 3 0 0 1-3.03 2.79Z"
        />
        <path
          className="clse6-1"
          d="M1679 1559.33a65.74 65.74 0 0 1-18.17 36.67 3.26 3.26 0 0 1-5.3-.92 68.89 68.89 0 0 1-6.77-41 65.81 65.81 0 0 1 18.16-36.68 3.26 3.26 0 0 1 5.3.92 68.93 68.93 0 0 1 6.78 41.01ZM165.33 1334.53c27.43 25.65 36.46 57.6 39.49 74.18.89 4.86-2.65 9.34-7.2 9.11a115.86 115.86 0 0 1-73.37-31.34c-27.44-25.65-36.46-57.6-39.5-74.18-.89-4.86 2.65-9.34 7.2-9.11a115.9 115.9 0 0 1 73.38 31.34Z"
        />
        <path
          className="clse6-2"
          d="M203.38 1328c13.8 36.37 8.56 69.31 4.38 85.59-1.23 4.77-6.25 7-10.21 4.58a128.5 128.5 0 0 1-52.42-64c-13.8-36.37-8.56-69.31-4.38-85.59 1.23-4.77 6.25-7 10.21-4.58a128.5 128.5 0 0 1 52.42 64Z"
        />
        <path
          className="clse6-3"
          d="M224.78 1331.58c-23.52 29.9-28 63-28.64 79.87-.19 4.94 3.94 8.78 8.4 7.8a119.27 119.27 0 0 0 68.12-43.13c23.53-29.9 28-63 28.64-79.87.2-4.94-3.93-8.78-8.39-7.8a119.29 119.29 0 0 0-68.13 43.13Z"
        />
        <path
          className="clse6-2"
          d="M274.28 1515.62a81.94 81.94 0 0 1-28.1 43.59 4.2 4.2 0 0 1-6.6-2 88.63 88.63 0 0 1-3-53.13 82 82 0 0 1 28.09-43.59 4.21 4.21 0 0 1 6.6 2 88.7 88.7 0 0 1 3.01 53.13Z"
        />
        <path
          className="clse6-2"
          d="M213.14 1530c17.39 6.09 27.35 19 31.76 26.1a4 4 0 0 1-1.71 5.77 56.73 56.73 0 0 1-39.8 1.06c-17.39-6.08-27.35-19-31.75-26.1a4 4 0 0 1 1.71-5.77 56.7 56.7 0 0 1 39.79-1.06Z"
        />
        <path
          className="clse6-2"
          d="M322.46 1737.63h-.16a3 3 0 0 1-2.83-3.16c1.95-35.59-3.35-68.18-15.79-96.85s-28.84-45.81-44.67-62.28c-15.26-15.88-31-32.31-43-58.87-15.1-33.62-19.46-73.81-13-119.45a3 3 0 1 1 5.94.85c-6.32 44.5-2.11 83.57 12.51 116.15 11.5 25.61 26.22 40.93 41.81 57.16 16.2 16.86 32.95 34.29 45.86 64.06 12.8 29.53 18.28 63 16.27 99.56a3 3 0 0 1-2.94 2.83Z"
        />
        <path
          className="clse6-1"
          d="M244.88 1341.94a135.42 135.42 0 0 1-37.38 75.47 6.7 6.7 0 0 1-10.9-1.89 141.83 141.83 0 0 1-13.95-84.37 135.42 135.42 0 0 1 37.35-75.47 6.71 6.71 0 0 1 10.91 1.89 141.92 141.92 0 0 1 13.97 84.37ZM464.32 1752h-.24a2 2 0 0 1-1.75-2.22l7.3-62.19a2 2 0 0 1 4 .47l-7.3 62.19a2 2 0 0 1-2.01 1.75ZM496.73 1752.78a2 2 0 0 1-2-1.74l-8.29-63.69a2 2 0 1 1 4-.51l8.29 63.69a2 2 0 0 1-1.73 2.24ZM584.11 1526.1l30.41 10.31-20.34 17.38a40.47 40.47 0 0 1-7-10.19 32.91 32.91 0 0 1-3.07-17.5Z"
        />
        <path
          className="clse6-3"
          d="M599.23 1574.66a145.37 145.37 0 0 1-286.81 33.56c12.33 1.29 21.7-.61 28.68-3.19 56.62-20.85 41.31-119.42 109.33-151.84 32.09-15.31 62.75-7.08 62.75-7.08a100 100 0 0 1 18.91 7.15c43.27 21.62 57.65 68.52 60.72 78.53a159 159 0 0 1 6.42 42.87Z"
        />
        <path
          className="clse6-1"
          d="M596.79 1601.33a145.46 145.46 0 0 1-125.14 117.61 86 86 0 1 1 125.14-117.61Z"
        />
        <circle className="clse6-1" cx={539.23} cy={1521.99} r={18.08} />
        <path
          className="clse6-1"
          d="M364.35 1644a63.38 63.38 0 0 1-8.12-.5 2 2 0 0 1 .51-4c7.36 1 26.36 1.76 43.76-11.24a60.34 60.34 0 0 0 21.24-30.42 2 2 0 0 1 3.83 1.17 63 63 0 0 1-61.22 45Z"
        />
        {children}
      </g>
    </svg>
  );
}
